import cn from "@/lib/cn";
import { formatImageUrl } from "@/lib/utils";
import { TTagListing } from "@/types/tags";
import { ArrowRightIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

type TTagCardProps = {
	tag: TTagListing;
};

export default function TagCard({ tag }: TTagCardProps) {
	return (
		<Link href={`/tags/${tag?.name}`}>
			<div className="group h-32 rounded bg-white p-4 shadow transition-all duration-300 hover:shadow-lg">
				<div className="flex h-full w-full flex-col justify-between gap-4">
					<div className="flex flex-col gap-4">
						<div className="flex items-center gap-x-1">
							<h3 className="text-lg font-semibold">{tag.name}</h3>
						</div>
					</div>

					{tag.products ? (
						<div className="flex items-center gap-2">
							<div className="flex items-center -space-x-4">
								{tag.products.map((productV2) => (
									<div key={productV2?.id} className="h-10 w-10 rounded-xl border-2 border-white">
										<Image
											src={formatImageUrl(productV2?.logo) || "/images/image-placeholder.svg"}
											alt={productV2?.name}
											className="h-full w-full rounded object-contain p-1 text-brand-primary"
											width={32}
											height={21}
										/>
									</div>
								))}
							</div>

							<span className="text-sm text-gray-600">
								+{tag?.products?.length - 3 > 0 ? tag?.products?.length - 3 : tag?.products?.length}{" "}
								products
							</span>

							<div
								className={cn(
									"ml-auto flex items-center justify-end"
								)}
							>
								<span>
									<ArrowRightIcon className="group h-8 w-8 rounded-full p-1 text-brand-primary transition-all duration-300 group-hover:bg-brand-primary group-hover:text-white" />
								</span>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</Link>
	);
}
